const SYNC_SETTING_TABS = {
  syncSchedule: {
    activeTabProperty: 'scheduleTabActive'
  },
  uploadFile: {
    activeTabProperty: 'fileUploadTabActive'
  },
  aeriesConnection: {
    activeTabProperty: 'aeriesConnectionTabActive'
  },
  oneRosterApi: {
    activeTabProperty: 'oneRosterApiConnectionActive'
  },
  uploadHistory: {
    activeTabProperty: 'uploadHistoryTabActive'
  },
  uploadSettings: {
    activeTabProperty: 'uploadSettingsTabActive'
  }
};

export default SYNC_SETTING_TABS;



// WEBPACK FOOTER //
// ./app/models/syncSettingTabs.js